import { forwardRef, Ref } from 'react';
import SignatureCanvasImport from 'react-signature-canvas';
import { MainSignaturePropsType } from '@/common/components/base/signatureCanvas/signature.type.ts';

const SignatureComponent =
  (SignatureCanvasImport as any).default ?? SignatureCanvasImport;

const SignatureMain = (props: MainSignaturePropsType, ref: Ref<any>) => {
  const { className, ...rest } = props;

  return (
    <SignatureComponent
      ref={ref}
      maxWidth={3}
      minWidth={1}
      dotSize={3}
      backgroundColor="white"
      canvasProps={{
        className: `sigCanvas ${className ?? ''}`,
      }}
      {...rest}
    />
  );
};

export default forwardRef(SignatureMain);
